import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3304993e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3304993e')) {
      api.createRecord('3304993e', component.options)
    } else {
      api.reload('3304993e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3304993e&", function () {
      api.rerender('3304993e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ScreenBuilder/index.vue"
export default component.exports